import {countryConfig} from '../../../../../country-config/country-config';
export const globalEnv = {...countryConfig.backend};
